import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import React, { Component, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import { GET_ACTIVE_DASHBOARD } from "helpers/url_api_constant";
import PropTypes from "prop-types";
import classnames from "classnames";
import { post } from "helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";

const Bi_Dashboard = props => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("0");
  const [dashboardUrl, setDashboardUrl] = useState([]);
  const toggle = tab => {
    if (activeTab != tab) {
      setActiveTab(tab);
    }
  };
  const compare = (a, b) => {
    // console.log(a, b);
    if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
      return -1;
    }
    if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
      return 1;
    }
    return 0;
  }
  const getBiDashboard = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ACTIVE_DASHBOARD, {});
      setDashboardUrl(res.data.dashboardConfigList.sort(compare));
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    getBiDashboard();
  }, []);
  const NavTabItem = ({ item, tabIndex }) => {
    return (
      <NavItem>
        <NavLink
          style={{ cursor: "pointer", textAlign: "center" }}
          className={classnames({
            active: activeTab === tabIndex,
          })}
          onClick={() => {
            toggle(tabIndex);
          }}
        >
          {item.TAB_NAME}
        </NavLink>
      </NavItem>
    );
  };
  NavTabItem.propTypes = {
    item: PropTypes.any,
    tabIndex: PropTypes.any,
  };
  const TabPaneItem = ({ item, tabIndex }) => {
    return (
      <TabPane tabId={tabIndex}>
        <Row style={{ minHeight: "88vh" }}>
          <Col sm="12" className="p-0">
            <iframe
              height="100%"
              width="100%"
              src={item.TAB_URL}
            />
          </Col>
        </Row>
      </TabPane>
    );
  };
  TabPaneItem.propTypes = {
    item: PropTypes.any,
    tabIndex: PropTypes.any,
  };
  return (
    <React.Fragment>
      <div className="page-content pb-1">
        <Container fluid>
          {/* <Row>
            <Col xl="12"> */}
          {/* <Card>
                <CardBody>
                  <CardTitle className="card-title mb-4 h4">
                    <h1 className="mb-0 font-size-20">
                      {props.t("BI Dashboard")}
                    </h1>
                  </CardTitle>
                </CardBody>
              </Card> */}
          {/* <Row> */}
          <Col xl="12">
            <Card className="m-0">
              <CardBody className="p-0">
                <Row>
                  <Col sm="1" className="pe-0">
                    <Nav className="nav flex-column nav-pills" tabs>
                      {dashboardUrl.map((item, index) => (
                        <NavTabItem
                          key={index.toString()}
                          tabIndex={index.toString()}
                          item={item}
                        />
                      ))}
                    </Nav>
                  </Col>
                  <Col sm="11" className="p-0">
                    <TabContent
                      activeTab={activeTab}
                      className="p-0 bi-lock-content"
                    >
                      {dashboardUrl.map((item, index) => (
                        <TabPaneItem
                          key={index.toString()}
                          tabIndex={index.toString()}
                          item={item}
                        />
                      ))}
                    </TabContent>
                  </Col>
                </Row>

                {/* <div class="row">
                    <div class="col-3">
                      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Home</a>
                        <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">Profile</a>
                        <a class="nav-link" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false">Messages</a>
                        <a class="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false">Settings</a>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">...</div>
                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">...</div>
                        <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">...</div>
                        <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">...</div>
                      </div>
                    </div>
                  </div> */}
              </CardBody>
            </Card>
          </Col>
          {/* </Row> */}
          {/* </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

Bi_Dashboard.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Bi_Dashboard }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Bi_Dashboard));
